import { React, DomeComponent } from "@lexriver/dome";
import css from './ButtonIcon.m.scss'
import { EnumIconNames } from "../../enums/EnumIconNames";


interface Attrs{
    iconName:EnumIconNames
    onClick:(e)=>void
    hoverText?:string
}

export class ButtonIcon extends DomeComponent<Attrs>{
    render(){
        return <button title={this.attrs.hoverText} onClick={this.attrs.onClick} class={css.buttonIcon}><span class={this.attrs.iconName}/></button>
    }
}